module.exports = __webpack_public_path__ + "a63dc430156a98a44a366304452614f0.svg";